global.application = {
  env: '{{env_type_name}}',
  endpoint: '{{web_url}}',
  use: {
    mock: false,
    debug: false,
    sentryUrl: '{{sentry_url}}',
  },
};


// WEBPACK FOOTER //
// ../config/environments/docker.js